/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { ContractsTypes, ContractsState } from './types';

const INITIAL_STATE: ContractsState = {
  contracts: {
    contract: [],
    currentPage: 1,
    postsPerPage: 20,
    total_entries: 0,
  },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};
const reducer: Reducer<ContractsState> = (state = INITIAL_STATE, { type, result, currentPage }) => {
  return produce(state, (draft) => {
    switch (type) {
      case ContractsTypes.GET_CONTRACTS_REQUEST:
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        draft.contracts = INITIAL_STATE.contracts;
        break;
      case ContractsTypes.GET_CONTRACTS_SUCCESS:
        draft.contracts.contract = result?.data?.contratos;
        draft.contracts.total_entries = result?.data?.total_rows;

        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ContractsTypes.GET_CONTRACTS_FAILURE:
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        draft.contracts = INITIAL_STATE.contracts;
        break;
      case ContractsTypes.SEARCH_CONTRACTS_REQUEST:
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ContractsTypes.SEARCH_CONTRACTS_SUCCESS:
        draft.contracts.contract = result?.data?.contratos;
        draft.contracts.total_entries = result?.data?.total_rows;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ContractsTypes.SEARCH_CONTRACTS_FAILURE:
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ContractsTypes.UPDATE_CURRENT_PAGE:
        draft.contracts.currentPage = currentPage;
        break;
      default:
    }
  });
};
export default reducer;
